<div class="admin-container">
  <div class="admin-tabs">
    <button (click)="selectTab('users')" [class.active]="activeTab === 'users'">Gestión de Usuarios</button>
    <button (click)="selectTab('categories')" [class.active]="activeTab === 'categories'">Gestión de Categorías</button>
    <button (click)="selectTab('competitions')" [class.active]="activeTab === 'competitions'">Gestión de Competiciones</button>
    <button (click)="selectTab('priority')" [class.active]="activeTab === 'priority'">Prioridad</button>
    @if (canManageInternalVideos) {
      <button (click)="selectTab('internalVideos')" [class.active]="activeTab === 'internalVideos'">Vídeos IA</button>
    }
    @if (canManageOrchestratorDb) {
      <button (click)="selectTab('orchestratorDb')" [class.active]="activeTab === 'orchestratorDb'">Orquestador DB</button>
    }
  </div>

  <div class="admin-content">
    @if (activeTab === 'users') {
      <app-user-management></app-user-management>
    }
    @if (activeTab === 'categories') {
      <app-category-management></app-category-management>
    }
    @if (activeTab === 'competitions') {
      <app-competition-management></app-competition-management>
    }
    @if (activeTab === 'priority') {
      <app-priority-management></app-priority-management>
    }
    @if (activeTab === 'internalVideos' && canManageInternalVideos) {
      <app-internal-video-management></app-internal-video-management>
    }
    @if (activeTab === 'orchestratorDb' && canManageOrchestratorDb) {
      <app-orchestrator-db-management></app-orchestrator-db-management>
    }
  </div>
</div>
